import { defineStore } from 'pinia';
import type { LocaleStoreState, CarrierItem, CarrierObj, CountryItem, CountryObj } from '#/locale';
export const useLocaleStore: any = defineStore({
	id: 'app-locale',
	state: (): LocaleStoreState => ({
		selectLanguage: 'En',
		selectCurrency: '',
		cid: '',
		userId: '',
		token: '',
		username: '',
		carrierList: [],
		countryList: [],
		belongArea: '',
		deviceType: '',
		countryObj: {},
		carrierObj: {} as CarrierObj,
		account: '',
		showLogin: 0,
		hotCity: [],
		currentwebSiteSource: ''
	}),
	actions: {
		setSelectLanguage(language: string) {
			this.selectLanguage = language;
		},
		setSelectCurrency(currency: string) {
			this.selectCurrency = currency;
		},
		setChannelCid(cid: string) {
			this.cid = cid;
		},
		setUserId(userId: string) {
			console.log(userId);
			this.userId = userId;
		},
		setToken(token: string) {
			this.token = token;
		},
		setUsername(username: string) {
			this.username = username;
		},
		setCarrierList(carrierList: CarrierItem[]) {
			this.carrierList = carrierList;
		},
		setCarrierObj(carrierObj: CarrierObj) {
			this.carrierObj = carrierObj;
		},
		setCountryList(list: CountryItem[]) {
			this.countryList = list;
		},
		setCountryObj(countryObj: CountryObj) {
			this.countryObj = countryObj;
		},
		setBelongArea(belongArea: string) {
			this.belongArea = belongArea;
		},
		setDeviceType(deviceType: string) {
			this.deviceType = deviceType;
		},
		setAccount(account: string) {
			this.account = account;
		},
		setShowLogin(time: number) {
			this.showLogin = time;
		},
		setHotCity(list: any[]) {
			this.hotCity = list;
		},
		setCurrentwebSiteSource(currentwebSiteSource: string) {
			this.currentwebSiteSource = currentwebSiteSource;
		}
	},
	getters: {
		getSelectLanguage(): string {
			return this.selectLanguage;
		},
		getSelectCurrency(): string {
			return this.selectCurrency;
		},
		getChannelCid(): string {
			return this.cid;
		},
		getUserId(): string {
			return this.userId;
		},
		getToken(): string {
			return this.token;
		},
		getUsername(): string {
			return this.username;
		},
		getCarrierList(): CarrierItem[] {
			return this.carrierList;
		},
		getCarrierObj(): CarrierObj {
			return this.carrierObj;
		},
		getCountryList(): CountryItem[] {
			return this.countryList;
		},
		getCountryObj(): CountryObj {
			return this.countryObj;
		},
		getBelongArea(): string {
			return this.belongArea;
		},
		getDeviceType(): string {
			return this.deviceType;
		},
		getAccount(): string {
			return this.account;
		},
		getShowLogin(): number {
			return this.showLogin;
		},
		getHotCity(): any[] {
			return this.hotCity;
		},
		getCurrentwebSiteSource(): string {
			return this.currentwebSiteSource;
		}
	},
	// 持久化存储，可以根据自己需求配置哈
	persist: process.client &&
	{
		storage: sessionStorage,
		paths: ['token', 'selectLanguage', 'selectCurrency', 'cid', 'userId', 'username', 'carrierList', 'carrierObj', 'countryObj', 'account', 'deviceType', 'belongArea']
	},
});

export const setSelectCurrency = (currency: string) => {
	useLocaleStore().setSelectCurrency(currency);
};
export const getSelectCurrency = (): string => {
	return useLocaleStore().getSelectCurrency;
};
export const setSelectLanguage = (language: string) => {
	useLocaleStore().setSelectLanguage(language);
};
export const getSelectLanguage = () => {
	return useLocaleStore().getSelectLanguage;
};
export const setChannelCid = (cid: string) => {
	useLocaleStore().setChannelCid(cid);
};
export const getChannelCid = () => {
	return useLocaleStore().getChannelCid;
};
export const setUserIdFun = (userId: string) => {
	useLocaleStore().setUserId(userId);
};
export const getUserIdFun = () => {
	return useLocaleStore().getUserId;
};
export const setToken = (token: string) => {
	useLocaleStore().setToken(token);
};
export const getTokenFun = () => {
	return useLocaleStore().getToken;
};
export const setUsername = (username: string) => {
	useLocaleStore().setUsername(username);
};
export const getUsernameFun = () => {
	return useLocaleStore().getUsername;
};
export const setCarrierList = (carrierList: CarrierItem[]) => {
	useLocaleStore().setCarrierList(carrierList);
};
export const getCarrierList = () => {
	return useLocaleStore().getCarrierList;
};
export const setCarrierObjFun = (carrierObj: CarrierObj) => {
	useLocaleStore().setCarrierObj(carrierObj);
};
export const getCarrierObjFun = () => {
	return useLocaleStore().getCarrierObj;
};
export const setCountryListFun = (list: CountryItem[]) => {
	useLocaleStore().setCountryList(list);
};
export const getCountryListFun = () => {
	return useLocaleStore().getCountryList;
};
export const setBelongAreaFun = (belongArea: string) => {
	useLocaleStore().setBelongArea(belongArea);
};
export const getBelongAreaFun = () => {
	return useLocaleStore().getBelongArea;
};
export const setDeviceTypeFun = (deviceType: string) => {
	useLocaleStore().setDeviceType(deviceType);
};
export const setAccountFun = (account: string) => {
	return useLocaleStore().setAccount(account);
};
export const getDeviceTypeFun = () => {
	return useLocaleStore().getDeviceType;
};

export const setCountryObjFun = (countryObj: CountryObj) => {
	useLocaleStore().setCountryObj(countryObj);
};
export const getCountryObjFun = () => {
	return useLocaleStore().getCountryObj;
};
export const getAccountFun = () => {
	return useLocaleStore().getAccount;
};
export const getShowLoginFun = () => {
	return useLocaleStore().getShowLogin;
};
export const setShowLoginFun = (time: number) => {
	return useLocaleStore().setShowLogin(time);
};
export const getHotCityFun = () => {
	return useLocaleStore().getHotCity;
};
export const setHotCityFun = (list: any[]) => {
	return useLocaleStore().setHotCity(list);
};
// 暂时不用
// export const getCurrentwebSiteSourceFun = () => {
// 	return useLocaleStore().getCurrentwebSiteSource;
// };
// export const setCurrentwebSiteSourceFun = (currentwebSiteSource: string) => {
// 	return useLocaleStore().setCurrentwebSiteSource(currentwebSiteSource);
// };
